import { render, staticRenderFns } from "./PendingIssues.vue?vue&type=template&id=755bd1af&scoped=true"
import script from "./PendingIssues.vue?vue&type=script&lang=js"
export * from "./PendingIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755bd1af",
  null
  
)

export default component.exports